import { IdCodNomeDTO, IdNomeDTO, IdNomeObsListDTO } from '@/interfaces/base-dto';
import IClientUnit, { ISetor, UnidadeParmDTO, UnidadesFilterDTO } from '@/interfaces/clientUnit';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { AxiosResponse } from 'axios';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function getClientUnits(filter: any = {}): Observable<IClientUnit[]> {
  return from(apiClient.get(ENDPOINTS.UNIDADE_CLIENTE, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function getClientUnit(id: string): Observable<IClientUnit> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/${id}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function updateClientUnit(payload: UnidadeParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.UNIDADE_CLIENTE, payload)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function saveClientUnitImage(id: number, payload: any): Observable<any> {
  return from(
    apiClient.putMultipartFormData(
      `${ENDPOINTS.UNIDADE_CLIENTE}/${id}${ENDPOINTS.UNIDADE_CLIENTE_IMAGEM}`,
      payload,
    ),
  ).pipe(map((r: any) => r.data));
}
export function deleteClientUnitImage(id: number): Observable<any> {
  return from(
    apiClient.delete(
      `${ENDPOINTS.UNIDADE_CLIENTE}/${id}${ENDPOINTS.UNIDADE_CLIENTE_IMAGEM}`,
    ),
  ).pipe(map((r: any) => r.data));
}

export function getSetoresUnidade(idUnidade: string): Observable<ISetor[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/${idUnidade}${ENDPOINTS.UNIDADE_CLIENTE_SETORES}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getAvailableTherapies(idUnit: string, simplified: boolean): Observable<IdNomeObsListDTO> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/${idUnit}/terapias/disponiveis`, {simplificadas: simplified})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getAvailableEnteralProducts(idUnit: string): Observable<IdNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/${idUnit}/prod-enterais/disponiveis`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getAvailableEnteralCalculationTypes(idUnit: string): Observable<IdNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/${idUnit}/enterais/tipos-calculo`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getAvailableTemplatesClientsUnit(): Observable<IdCodNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}${ENDPOINTS.UNIDADE_CLIENTE_TEMPLATES}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getBillingVias(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE}/vias-faturamento`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function buildClientUnitsXlsReport(filters: UnidadesFilterDTO): Observable<AxiosResponse> {
  return from(
      apiClient.download(ENDPOINTS.UNIDADE_CLIENTE_REPORT_XLS, filters),
  );
}

export function getMulticompartOptionsClientUnit(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE_OPC_BOLSA_MULTI}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getMulticompartWeekDays(): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE_DIAS_BOLSA_MULTI}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getScheduleProductionTypes(): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.UNIDADE_CLIENTE_TIPOS_AGEND_PROD}`)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}